// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.condition:not(:last-child) {
  margin-right: 2px;
}

[data-condition-id]:not(.placeholder) {
  position: relative;
  background-color: var(--t-colors-brand-50);
  border: 1px solid transparent;
}

[data-condition-id]:hover {
  border-color: var(--t-colors-border-300);
}

[data-condition-id]:not(.placeholder)::before,
[data-condition-id]:not(.placeholder)::after {
  color: var(--t-colors-text-300);
  background-color: var(--t-colors-brand-500);

  white-space: nowrap;
  pointer-events: none;
}

[data-condition-id]:not(.placeholder)::before {
  content: '<' attr(data-condition-id) '>';
}

[data-condition-id]:not(.placeholder)::after {
  content: '</' attr(data-condition-id) '>';
}
`, "",{"version":3,"sources":["webpack://./shared/domains/pleditor@next/plugins/Conditions/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,+BAA+B;EAC/B,2CAA2C;;EAE3C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":[".condition:not(:last-child) {\n  margin-right: 2px;\n}\n\n[data-condition-id]:not(.placeholder) {\n  position: relative;\n  background-color: var(--t-colors-brand-50);\n  border: 1px solid transparent;\n}\n\n[data-condition-id]:hover {\n  border-color: var(--t-colors-border-300);\n}\n\n[data-condition-id]:not(.placeholder)::before,\n[data-condition-id]:not(.placeholder)::after {\n  color: var(--t-colors-text-300);\n  background-color: var(--t-colors-brand-500);\n\n  white-space: nowrap;\n  pointer-events: none;\n}\n\n[data-condition-id]:not(.placeholder)::before {\n  content: '<' attr(data-condition-id) '>';\n}\n\n[data-condition-id]:not(.placeholder)::after {\n  content: '</' attr(data-condition-id) '>';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
